import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    Typography,
} from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "../../assets/images/plus-circle-fill.svg"
import { ReactComponent as HistoryIcon } from "../../icons/history-2-black.svg"

const EmailTypography = (props) => {
    return (
        <Typography fontFamily="Angsana New" fontSize={18} {...props} component="span">{props.children}</Typography>
    )
}

const ReceiverForm = (props) => {
    return (
        <Box {...props}>
            {/* thai */}
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">เรียน </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[ชื่อผู้ประเมิน]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">คุณได้รับ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อแบบฟอร์มการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">สำหรับ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อพนักงาน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">โดยสามารถเริ่มประเมินได้ตั้งแต่วันที่</EmailTypography>
                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[วันที่เริ่มต้นการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">จนถึงวันที่</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[วันที่สิ้นสุดการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">และสามารถดูรายละเอียดในระบบ IPOP PMS</EmailTypography>
                </Grid>
            </Grid>
            <Grid container my={2}>
                <Grid item display="flex">
                    <EmailTypography color="#000" fontWeight="700">ข้อมูลพนักงาน</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex" xs={4}>
                    <EmailTypography color="#939393" fontWeight="400">ชื่อ:</EmailTypography>
                </Grid>
                <Grid item display="flex" xs={8}>
                    <EmailTypography color="#567DF4" fontWeight="700">[ชื่อพนักงาน]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex" xs={4}>
                    <EmailTypography color="#939393" fontWeight="400">ตำแหน่งงาน:</EmailTypography>
                </Grid>
                <Grid item display="flex" xs={8}>
                    <EmailTypography color="#567DF4" fontWeight="700">[ตำแหน่ง]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex" xs={4}>
                    <EmailTypography color="#939393" fontWeight="400">หน่วยงาน:</EmailTypography>
                </Grid>
                <Grid item display="flex" xs={8}>
                    <EmailTypography color="#567DF4" fontWeight="700">[องค์กร]</EmailTypography>
                </Grid>
            </Grid>
            <Divider />
            <Grid container mb={1}>
                <Grid item display="flex" xs={12}>
                </Grid>
            </Grid>
            {/* english */}
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Dear </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[Evaluator Name]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">You recieved</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Form Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">for</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Employee Name], </EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please proceed the evaluation from</EmailTypography>
                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Start Date]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">to</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[End Date].</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please visit IPOP PMS for further detail.</EmailTypography>
                </Grid>
            </Grid>
            <Grid container my={2}>
                <Grid item display="flex">
                    <EmailTypography color="#000" fontWeight="700">Employee Detail</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex" xs={4}>
                    <EmailTypography color="#939393" fontWeight="400">Name:</EmailTypography>
                </Grid>
                <Grid item display="flex" xs={8}>
                    <EmailTypography color="#567DF4" fontWeight="700">[Employee Name]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex" xs={4}>
                    <EmailTypography color="#939393" fontWeight="400">Position:</EmailTypography>
                </Grid>
                <Grid item display="flex" xs={8}>
                    <EmailTypography color="#567DF4" fontWeight="700">[Position]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex" xs={4}>
                    <EmailTypography color="#939393" fontWeight="400">Organization:</EmailTypography>
                </Grid>
                <Grid item display="flex" xs={8}>
                    <EmailTypography color="#567DF4" fontWeight="700">[Business Unit]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={4}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "220px", height: "40px", background: "#0A84FF", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <EmailTypography color="#FFF" fontWeight="700">ดูรายละเอียด (Detail)</EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>อีเมลฉบับนี้ส่งโดยระบบ IPOP PMS แบบอัตโนมัติ หากมีข้อสงสัยรบกวนติดต่อเจ้าหน้าที่ ที่ดูแลหน่วยงาน ของท่านหรือช่องทางการติดต่อที่หน่วยงานของท่านแจ้งไว้
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>(This email was automatically generated by IPOP PMS. Should you require any assistance, please contact via communication channels provided by your company.)
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    )
}

const StartDateForm = (props) => {
    return (
        <Box {...props}>
            {/* thai */}
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">เรียน </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[ชื่อพนักงาน]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">กรุณาเข้าจัดทำ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อแบบประเมินเป้าหมาย]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">และส่งภายในวันทื่</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[วันที่สิ้นสุดการประเมินเป้าหมาย]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">และสามารถเข้าดูรายละเอียดในระบบ IPOP PMS</EmailTypography>
                </Grid>
            </Grid>
            <Divider />
            <Grid container mb={1}>
                <Grid item display="flex" xs={12}>
                </Grid>
            </Grid>
            {/* english */}
            <Grid container mb={2}>
                <Grid item display="flex" >
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Dear </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[Employee Name]</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={4}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please complete the</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Form Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">and submit by</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[End Date]. </EmailTypography>

                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please visit IPOP PMS for further detail.</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={4}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "220px", height: "40px", background: "#0A84FF", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <EmailTypography color="#FFF" fontWeight="700">ดูรายละเอียด (Detail)</EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>อีเมลฉบับนี้ส่งโดยระบบ IPOP PMS แบบอัตโนมัติ หากมีข้อสงสัยรบกวนติดต่อเจ้าหน้าที่ ที่ดูแลหน่วยงาน ของท่านหรือช่องทางการติดต่อที่หน่วยงานของท่านแจ้งไว้
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>(This email was automatically generated by IPOP PMS. Should you require any assistance, please contact via communication channels provided by your company.)
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    )
}

const EndDateForm = (props) => {
    return (
        <Box {...props}>
            {/* thai */}
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">เรียน </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[ชื่อพนักงาน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">, </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[ชื่อพนักงาน]</EmailTypography>


                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">กรุณาเข้าดำเนินการ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อขั้นตอนการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">สำหรับ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อแบบฟอร์มการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">ของ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อพนักงาน]</EmailTypography>

                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">ภายในวันที่</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[วันที่สิ้นสุดการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">และสามารถดูรายละเอียดในระบบ IPOP PMS</EmailTypography>
                </Grid>
            </Grid>
            <Divider />
            {/* english */}
            <Grid container my={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Dear </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[Manager Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">, </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[Employee Name]</EmailTypography>


                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please complete the</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Step Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">of</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Form Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">for</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Employee Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">by</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Step End Date]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">.</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={4}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please visit IPOP PMS for further detail.</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={4}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "220px", height: "40px", background: "#0A84FF", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <EmailTypography color="#FFF" fontWeight="700">ดูรายละเอียด (Detail)</EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>อีเมลฉบับนี้ส่งโดยระบบ IPOP PMS แบบอัตโนมัติ หากมีข้อสงสัยรบกวนติดต่อเจ้าหน้าที่ ที่ดูแลหน่วยงาน ของท่านหรือช่องทางการติดต่อที่หน่วยงานของท่านแจ้งไว้
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>(This email was automatically generated by IPOP PMS. Should you require any assistance, please contact via communication channels provided by your company.)
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    )
}

const OverdueForm = (props) => {
    return (
        <Box {...props}>
            {/* thai */}
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">เรียน </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[ชื่อพนักงาน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">, </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[ชื่อพนักงาน]</EmailTypography>


                </Grid>
            </Grid>
            <Grid container m={0}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">กรุณาเข้าดำเนินการ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อขั้นตอนการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">สำหรับ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อแบบฟอร์มการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">ของ</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[ชื่อพนักงาน]</EmailTypography>

                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">ให้เรียบร้อย เนื่องจากเลยกำหนดเมื่อวันที่</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[วันที่สิ้นสุดการประเมิน]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">และสามารถดูรายละเอียดในระบบ IPOP PMS</EmailTypography>
                </Grid>
            </Grid>
            <Divider />
            {/* english */}
            <Grid container my={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Dear </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[Manager Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">, </EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[Employee Name]</EmailTypography>


                </Grid>
            </Grid>
            <Grid container mb={0}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please complete the</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Step Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">of</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Form Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">for</EmailTypography>
                    <EmailTypography color="#567DF4" fontWeight="700">[Employee Name]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">, which was due on</EmailTypography>
                    <EmailTypography color="#567DF4" sx={{ mr: "3px" }} fontWeight="700">[Step End Date]</EmailTypography>
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">.</EmailTypography>
                </Grid>
            </Grid>
            <Grid container mb={2}>
                <Grid item display="flex">
                    <EmailTypography sx={{ mr: "3px" }} fontWeight="400">Please visit IPOP PMS for further detail.</EmailTypography>
                </Grid>
            </Grid>
            <Grid container my={4}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "220px", height: "40px", background: "#0A84FF", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <EmailTypography color="#FFF" fontWeight="700">ดูรายละเอียด (Detail)</EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>อีเมลฉบับนี้ส่งโดยระบบ IPOP PMS แบบอัตโนมัติ หากมีข้อสงสัยรบกวนติดต่อเจ้าหน้าที่ ที่ดูแลหน่วยงาน ของท่านหรือช่องทางการติดต่อที่หน่วยงานของท่านแจ้งไว้
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mb={1}>
                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                    <Box sx={{ width: "500px", textAlign: "center" }}>
                        <EmailTypography color="#939393" fontWeight="400" fontSize={16}>(This email was automatically generated by IPOP PMS. Should you require any assistance, please contact via communication channels provided by your company.)
                        </EmailTypography>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    )
}

const PreviewEmailTemplate = (props) => {
    const { banner, type, setValue } = { ...props }
    const { t } = useTranslation()
    const handleClose = () => {
        setValue(false)
    }

    const GetContentByType = (props) => {
        const { type } = { ...props }
        if (type === "receive") {
            return <ReceiverForm sx={{ mt: "20px", px: "5px" }} />
        } else if (type === "start_date") {
            return <StartDateForm sx={{ mt: "20px", px: "5px" }} />
        } else if (type === "end_date") {
            return <EndDateForm sx={{ mt: "20px", px: "5px" }} />
        } else if (type === "overdue") {
            return <OverdueForm sx={{ mt: "20px", px: "5px" }} />
        }
    }

    const textType = (val) => {
        let result = ""
        switch (val) {
            case "receive":
                result = "Receive Form"
                break
            case "start_date":
                result = "Form Start Date"
                break
            case "end_date":
                result = "Before and until End Date/Time"
                break
            case "overdue":
                result = "After End Date/Time (Overdue)"
                break
            default:
                break
        }
        return result
    }

    return (
        <React.Fragment>
            <Dialog
                onBackdropClick={() => { return false }}
                open={props.open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth={true}
                aria-labelledby="preview-email-template-title"
                aria-describedby="preview-email-template-description"
            >
                <DialogTitle id="preview-email-template" sx={{ display: "flex", alignItems: "center" }}>
                    <HistoryIcon />
                    <Typography fontSize={24} fontWeight={600} sx={{ ml: 1 }}>{t("emailNotificationCenter.label.dialog.previewEmail")} {`(${textType(type)})`}</Typography>
                    <Box sx={{ position: "absolute", right: 0, margin: "20px 18px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
                </DialogTitle>
                <Divider sx={{ mx: "18px" }} />
                <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
                    <Box sx={{}}>
                        {/* <Box> */}
                            <img src={banner} width="536" height="177" />
                        {/* </Box> */}
                        <GetContentByType type={type} />
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}
export default PreviewEmailTemplate
